import { render, staticRenderFns } from "./InvitationSectionIcon.vue?vue&type=template&id=d2924b00"
import script from "./InvitationSectionIcon.vue?vue&type=script&lang=js"
export * from "./InvitationSectionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports